import { useEffect, useState } from 'react';
import { retrieveCustomization } from '../../supplementary_components/userDataDelegate';

export const MENU_LAYOUT_KEY = 'menuLayout';

export const readClassicMenu = () => retrieveCustomization(MENU_LAYOUT_KEY) === 'classic';

export const useClassicMenu = () => {
    const [classic, setClassic] = useState(readClassicMenu);
    useEffect(() => {
        const sync = () => setClassic(readClassicMenu());
        window.addEventListener('customizations-changed', sync);
        return () => window.removeEventListener('customizations-changed', sync);
    }, []);
    return classic;
};
